module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/spqr-rijtjes-vragend-voornaamwoord.json
// module id = 1312
// module chunks = 250770760526458